<template>
<div>

	<div class="container-fluid">

		<div class="row">

			<div class="col-sm-12 col-xl-5 offset-xl-1">
				<b-jumbotron class="mb-0 pb-4 pt-4 h-100">
					<h1 class="display-4">Onder de Boompjes</h1>
					<p class="lead mt-4">
						Selecteer een veiling om te beginnen
					</p>

					<auction-select
						class="mb-2"
						:no-border-radius="false"
						:reset="true"
					/>
				</b-jumbotron>
			</div>

			<div class="col-sm-12 col-xl-5 mt-sm-4 mt-xl-0">
				<div class="row h-100 align-items-center">
					<div class="col-6 pr-1 pb-2">
						<dashboard-icon-button
							toName="auctionList"
							buttonTitle="Veilingen"
							iconName="gavel"
						/>

					</div>
					<div class="col-6 pl-1 pb-2">
						<dashboard-icon-button
							toName="categoryList"
							buttonTitle="Categorieën"
							iconName="cubes"
						/>
					</div>

					<div class="col-6 pr-1 pb-2">
						<dashboard-icon-button
							toName="personList"
							buttonTitle="Personen"
							iconName="users"
						/>
					</div>

					<div class="col-6 pl-1 pb-2">
						<dashboard-icon-button
							toName="itemsList"
							buttonTitle="Kavels"
							iconName="align-justify"
						/>
					</div>

					<div class="col-6 pr-1">
						<dashboard-icon-button
							toName="tagList"
							buttonTitle="Tags"
							iconName="tags"
						/>
					</div>

					<div class="col-6 pl-2">
            <dashboard-icon-button
              toName="planning"
              buttonTitle="Planning"
              iconName="calendar"
            />
          </div>
				</div>
			</div>

		</div>

	</div>

</div>
</template>

<script>
import AuctionSelect from '@/components/elements/AuctionSelect'
import DashboardIconButton from '@/components/elements/DashboardIconButton'

export default {
	name: 'Dashboard',
	components: {
		AuctionSelect,
		DashboardIconButton,
	},
	data() {
		return {
			message: 'Dashboard'
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// DashboardLanding.vue?cd521c5a